export default "__VITE_ASSET__9757b01e__"